module.exports = __webpack_public_path__ + "img/Tom.6c167c56.jpg";